// Velo API Reference: https://www.wix.com/velo/reference/api-overview/introduction

$w.onReady(function () {
    // Assuming these are the IDs after testing:
    const quantityInput = $w("#input46"); // Change as needed
    const quantityDropdown = $w("#dropdown3"); // Change as needed
    const addToCartButton = $w("#button1"); // Change as needed

    // Log to ensure that elements are selected correctly
    console.log("Quantity Input:", quantityInput);
    console.log("Quantity Dropdown:", quantityDropdown);
    console.log("Add to Cart Button:", addToCartButton);

    // Check if the elements are enabled and visible
    console.log("Quantity Input is enabled:", quantityInput.enabled);
    console.log("Quantity Input is visible:", quantityInput.isVisible);
    console.log("Quantity Dropdown is enabled:", quantityDropdown.enabled);
    console.log("Quantity Dropdown is visible:", quantityDropdown.isVisible);
    console.log("Add to Cart Button is enabled:", addToCartButton.enabled);
    console.log("Add to Cart Button is visible:", addToCartButton.isVisible);

    // Set default value for quantity input as a string
    quantityInput.value = "7"; // Set default quantity to "7" (as a string)
    console.log("Default quantity set to 7 in input.");

    // Function to update the state of the Add to Cart button
    function updateButtonState(quantity) {
        console.log(`Current quantity: ${quantity}`);
        if (quantity < 7) {
            addToCartButton.disable();
            console.log("Add to Cart button disabled.");
        } else {
            addToCartButton.enable();
            console.log("Add to Cart button enabled.");
        }
    }

    // Listen for key press events in the quantity input
    quantityInput.onKeyPress(() => {
        console.log("Key press event triggered on input.");
        const quantity = parseInt(quantityInput.value, 10);
        console.log(`Quantity input changed to: ${quantity}`);
        updateButtonState(quantity);
    });

    // Listen for changes in the dropdown using onChange
    quantityDropdown.onChange(() => {
        console.log("Dropdown change event triggered.");
        const quantity = parseInt(quantityDropdown.value, 10);
        console.log(`Quantity dropdown changed to: ${quantity}`);
        updateButtonState(quantity);
    });
});